export default __webpack_public_path__ + "static/media/Witbooker_AI_EN.89ce9a00.png";